import { useQuery } from 'react-query'
import request from '../request'

export const useGetAdminStats = () => {
  return useQuery<{ organizations: number; users: number; dealerships: number }, Error>(
    ['admin', 'stats'],
    () =>
      request({
        url: `/admin/stats`,
        method: 'GET',
      }).then((res: any) => res.data),
  )
}
